import { ImageTheme } from '@/components/Image/theme';
import { tw } from '@/utils/tw';
import BaseArticleTeaserDefaultTheme from 'base/components/ArticleTeaser/Default/theme';

const Image = tw.theme({
  extend: ImageTheme,
  base: `aspect-default`,
});

const ArticleTeaserDefault = tw.theme({
  extend: BaseArticleTeaserDefaultTheme,
  slots: {
    caption: `text-gray-600`,
    description: `hidden`,
  },
  variants: {
    variant: {
      horizontal: {
        caption: ``,
        headline: `text-headline-alternative-md sm:grid-cols-4:text-headline-alternative-sm md:grid-cols-7:text-headline-alternative-lg`,
      },
      vertical: {
        caption: `group-[.bg]/box:mx-4`,
        headline: `text-headline-alternative-xs grid-cols-7:text-headline-alternative-sm sm:text-headline-alternative-sm sm:grid-cols-4:text-headline-alternative-sm sm:grid-cols-5:text-headline-alternative-md sm:grid-cols-7:text-headline-alternative-lg md:grid-cols-4:text-headline-alternative-md md:grid-cols-7:text-headline-alternative-xl group-[.bg]/box:mx-4 group-[.bg]/box:mb-4`,
      },
    },
  },
});

export default Object.assign(ArticleTeaserDefault, { Image });
